import React from 'react';

import { SkeletonBlock, SkeletonOverlay, SKELETON_TOKENS } from 'components/shared';

const COLUMN_COUNT = 3;
const CARD_COUNT = 3;

const panel: React.CSSProperties = {
    backgroundColor: SKELETON_TOKENS.panel,
    borderRadius: SKELETON_TOKENS.radius,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

export default function CookBoardSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay
            isLoading={isLoading}
            background={SKELETON_TOKENS.appBackground}
            style={{ flexDirection: 'row', justifyContent: 'space-between' }}
        >
            {Array.from({ length: COLUMN_COUNT }, (_, column) => (
                <div
                    key={column}
                    style={{ width: '33%', display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                    <div style={panel}>
                        <SkeletonBlock height={24} width="60%" />
                    </div>
                    {Array.from({ length: CARD_COUNT }, (_, card) => (
                        <div key={card} style={panel}>
                            <SkeletonBlock height={20} width="70%" />
                            <SkeletonBlock height={16} />
                            <SkeletonBlock height={16} width="40%" />
                        </div>
                    ))}
                </div>
            ))}
        </SkeletonOverlay>
    );
}
